import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { LocationType } from '@guryou/core/build/locations';
import { Block, CheckIcon, HiddenField, LocationIcon } from '@guryou/html-components';
import { Box } from '@material-ui/core';
import Avatar from '@material-ui/core/Avatar';
import Grid from '@material-ui/core/Grid';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';

const useStyles = makeStyles(theme => ({
  cube: {
    position: 'relative',
    width: 145,
    minHeight: 140,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'flex-end', // push text down
    cursor: 'pointer',
    transition: '0.3s',
    borderRadius: theme.shape.borderRadius,
    border: '1px solid #ccc',
    backgroundColor: '#f9f9f9',
    paddingTop: theme.spacing(8), // space for avatar
    paddingBottom: theme.spacing(1),
    marginBottom: 4,
    textAlign: 'center',
    '&:hover': {
      backgroundColor: '#efefef',
      borderColor: '#888',
    },
  },
  selected: {
    borderColor: '#3aa61b',
    backgroundColor: '#f5fff2',
  },
  avatar: {
    position: 'absolute',
    top: theme.spacing(2),
    width: theme.spacing(7),
    height: theme.spacing(7),
    backgroundColor: '#bdbdbd',
    color: '#fff',
    fontSize: '1.2rem',
    transition: '0.3s',
  },
  avatarSelected: {
    backgroundColor: '#3aa61b',
    // color: '#212121',
  },
  nameText: {
    fontSize: '0.80rem',
    fontWeight: 600,
    color: '#333',
    wordWrap: 'break-word',
    maxWidth: '100%',
    whiteSpace: 'wrap',
  },
}));

const SelectableLocationGroup = ({ onChange, value = LocationType.providerLocation }) => {
  const [selectedId, setSelectedId] = useState(value);
  const { t } = useTranslation();
  const classes = useStyles();

  const locationOptions = [
    { label: t('GENERAL.providerLocation'), value: LocationType.providerLocation },
    { label: t('GENERAL.chooseLocationFromMap'), value: LocationType.mapLocation },
    { label: t('GENERAL.onlineLocation'), value: LocationType.plainNote },
  ];

  const selectLocation = id => {
    setSelectedId(id);
    onChange && onChange(id);
  };

  return (
    <Block margin={0} marginBottom={2}>
      <Grid container justifyContent="space-between">
        {locationOptions?.map(location => {
          const isSelected = selectedId === location.value;
          return (
            <Grid item key={location.value}>
              <Box
                elevation={isSelected ? 6 : 2}
                className={`${classes.cube} ${isSelected ? classes.selected : ''}`}
                onClick={() => selectLocation(location.value)}
              >
                <Avatar className={`${classes.avatar} ${isSelected ? classes.avatarSelected : ''}`}>
                  {isSelected ? <CheckIcon /> : <LocationIcon />}
                </Avatar>
                <Typography className={classes.nameText}>{location.label}</Typography>
              </Box>
            </Grid>
          );
        })}
      </Grid>
      <HiddenField name="locationType" value={selectedId} />
    </Block>
  );
};

export default SelectableLocationGroup;
